<template>
	<div class="specInfo" v-if="specDispFlg == 1">
		<template v-for="i in 10">
			<!-- スペック情報に設定がある部分のみ表示する。 -->
			<dl :class="'specRow' + i"
				v-if="ptInitData.productInfo[`SPEC_TITLE${i}`] || ptInitData.productInfo[`SPEC_DTL${i}`]" :key="i">
				<dt :class="'specTitle' + i" v-html="ptInitData.productInfo[`SPEC_TITLE${i}`]"></dt>
				<dd :class="'specData' + i" v-html="ptInitData.productInfo[`SPEC_DTL${i}`]"></dd>
			</dl>
		</template>
	</div>
</template>
<script>
export default {
	name: 'SpecInfo',
	props: {
		ptInitData: {
			type: Object,
			default: null
		},
		specDispFlg:{
			type: Number,
			default: 0
		}
	},
	data: function () {
		return {
		}
	}
}
</script>